var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 210",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9528 104.862L89.5277 20.1602L74.9487 14L0 61.4333V182.583L14.5791 188.743L100 156.608L78.9528 104.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23 99.6115L82.2424 149.054L2.42349 179.082V64.1027V62.7675L71.9147 18.7882L62.0712 98.4049L61.9941 99.0288L62.23 99.6115Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 4.84697
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 118,
    fontFamily: "Raleway, Arial, sans-serif",
    fontSize: 110,
    fontWeight: 800,
    fill: "black",
    letterSpacing: -2
  }, "THESIS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 180,
    fontFamily: "Raleway, Arial, sans-serif",
    fontSize: 56,
    fontWeight: 600,
    fill: "black"
  }, ".center")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98729aec93c6f62584abd44fd577eeaf.svg";
export { ForwardRef as ReactComponent };